export default "__VITE_ASSET__DOaoBqYl__"